import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Flex, useCounter, Text, Container } from "@chakra-ui/react"

type CounterProps = {
    max?: number;
    min?: number;
    onChange: (value: number | string) => void;
}

const Counter = (props: CounterProps) => {
    const counter = useCounter({
      max: props.max || 100000,
      min: props.min || 0,
      step: 1,
      defaultValue: 0
    })
  
    const increment = () => {
      counter.increment();
      props.onChange(counter.value);
    };
      
    const decrement = () => {
      counter.decrement();
      props.onChange(counter.value);
    };
    return (
      <Flex
        paddingTop={3}
        paddingBottom={3}
        paddingRight={26}
        borderRadius={100}
        background="transparent"
        paddingLeft={26}
        alignItems='center'
        justifyContent='space-between'
        width={115}
      >
        <Container  paddingLeft={2}
            paddingRight={2}
            paddingTop={2}
            cursor="pointer"  
            marginRight={2}
            verticalAlign="center"
            onClick={decrement}
            background="#FBFBFB"
            borderRadius="45px"
            boxShadow="0px 21.164px 42.328px -10.1587px" 
            paddingBottom={2}>
        <MinusIcon h={3} w={3} />
        </Container>
        <Text>{counter.value}</Text>
        <Container  paddingLeft={2}
            paddingRight={2}
            paddingTop={2}
            cursor="pointer"  
            marginLeft={2}
            onClick={increment}
            verticalAlign="center"
            background="#FBFBFB"
            borderRadius="45px"
            boxShadow="0px 21.164px 42.328px -10.1587px" 
            paddingBottom={2}>
        <AddIcon h={3} w={3} />
        </Container>
      </Flex>
    )
  };

  export { Counter };